import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const ContactSection = () => {

  return (
    <section id="contact" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Get In Touch</h2>
          <div className="w-24 h-1 bg-[#8B1818] mx-auto"></div>
          <p className="text-lg text-gray-600 mt-6 max-w-2xl mx-auto">
            Ready to start your project? Contact us today for a consultation.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="bg-white rounded-xl shadow-xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>
            <div className="space-y-6">
              <div className="flex items-start gap-4 py-4 border-b border-gray-200">
                <div className="w-12 h-12 bg-[#8B1818] rounded-lg flex items-center justify-center flex-shrink-0">
                  <Phone size={24} className="text-white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">Phone</div>
                  <a href="tel:01639618481" className="text-lg text-gray-600 hover:text-[#8B1818] transition-colors duration-200">
                    01639 618 481
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 py-4 border-b border-gray-200">
                <div className="w-12 h-12 bg-[#000080] rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail size={24} className="text-white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">Email</div>
                  <a href="mailto:info@ixusgroup.com" className="text-lg text-gray-600 hover:text-[#000080] transition-colors duration-200">
                    info@ixusgroup.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 py-4">
                <div className="w-12 h-12 bg-gray-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin size={24} className="text-white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900 mb-1">Address</div>
                  <p className="text-lg text-gray-600">
                    Unit 7 Kenfig Industrial Estate<br />
                    Margam, Port Talbot<br />
                    SA13 2PE
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Business Hours */}
          <div className="bg-white rounded-xl shadow-xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Business Hours</h3>
            <div className="space-y-6">
              <div className="flex items-center justify-between py-4 border-b border-gray-200">
                <span className="text-lg text-gray-700 font-medium">Monday - Friday</span>
                <span className="text-lg font-semibold text-gray-900">8:30 AM - 5:00 PM</span>
              </div>
              <div className="flex items-center justify-between py-4 border-b border-gray-200">
                <span className="text-lg text-gray-700 font-medium">Saturday</span>
                <span className="text-lg font-semibold text-gray-900">Closed</span>
              </div>
              <div className="flex items-center justify-between py-4 border-b border-gray-200">
                <span className="text-lg text-gray-700 font-medium">Sunday</span>
                <span className="text-lg font-semibold text-gray-900">Closed</span>
              </div>
              <div className="mt-8 p-6 bg-gradient-to-br from-red-50 to-white rounded-lg border-2 border-[#8B1818]">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-3 h-3 bg-[#8B1818] rounded-full animate-pulse"></div>
                  <span className="text-xl font-bold text-[#8B1818]">24/7 Emergency Support</span>
                </div>
                <p className="text-gray-600 ml-6">Available for urgent requests anytime, day or night</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;